import { httpClient } from '../http/httpClient'

export async function updateConfig(id: string, body: any) {
  const { data } = await httpClient.put<Config[]>(`/config/${id}`, body)

  return data
}
